/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_C0 as C0,
  rec_CeldaEditable as CeldaEditable,
  rec_Componente_A0_65_48 as Componente_A0_65_48,
  rec_E0 as E0,
  rec_JSXRuntime as JSXRuntime,
  rec_O0 as O0,
  rec_React as React,
  rec_S0 as S0,
  rec_T0 as T0,
  rec_b0 as b0,
  rec_h0 as h0,
  rec_ii as ii,
  rec_m0 as m0,
  rec_w0 as w0,
  rec_x0 as x0,
  rec_y0 as y0,
} from "../../runtime/index.jsx";
export function TablaOrganigrama({
  filas: e,
  columnas: t,
  onGuardar: n,
  editorEspecial: r,
  onAbrirFila: i,
  atenuada: a = () => !1,
  alto: o = `70vh`,
  etiqueta: s = `Hoja`,
}) {
  let c = (0, React.useRef)(null),
    [l, u] = (0, React.useState)(null),
    [f, p] = (0, React.useState)({}),
    [m, h] = (0, React.useState)({
      r: 0,
      c: 0,
    }),
    [g, _] = (0, React.useState)(null),
    [v, y] = (0, React.useState)(() => new Set()),
    [b, x] = (0, React.useState)(0),
    [S, C] = (0, React.useState)(600),
    [w, T] = (0, React.useState)(null),
    E = (0, React.useMemo)(() => new Map(e.map((e) => [e.id, e])), [e]),
    D = (0, React.useMemo)(() => e.map((e) => e.id).join(`,`), [e]),
    O = (0, React.useCallback)(
      (n, r) => y0(b0(e, r, t), n, t).map((e) => e.id),
      [e, t],
    ),
    [k, A] = (0, React.useState)(() => ({
      conjunto: D,
      ids: O(null, {}),
    }));
  k.conjunto !== D &&
    A({
      conjunto: D,
      ids: O(l, f),
    });
  let j = (0, React.useMemo)(
      () => k.ids.map((e) => E.get(e)).filter(Boolean),
      [k, E],
    ),
    M = j.length,
    N = Math.min(m.r, Math.max(0, M - 1)),
    P = Math.min(m.c, t.length - 1),
    F = j[N],
    I = t[P],
    L = (0, React.useMemo)(() => t.map((e) => e.ancho ?? 140), [t]),
    R = (0, React.useMemo)(
      () =>
        L.reduce((e, t, n) => [...e, (e[n - 1] ?? 0) + (n ? L[n - 1] : 0)], []),
      [L],
    ),
    z = L.reduce((e, t) => e + t, 0),
    ee = t.reduce((e, t, n) => (t.fija ? e + L[n] : e), 0);
  function te(e, t) {
    (u(e),
      p(t),
      A({
        conjunto: D,
        ids: O(e, t),
      }),
      h({
        r: 0,
        c: P,
      }));
  }
  (0, React.useLayoutEffect)(() => {
    let e = c.current;
    if (!e) return;
    let t = () => C(e.clientHeight || 600);
    if ((t(), typeof ResizeObserver > `u`)) return;
    let n = new ResizeObserver(t);
    return (n.observe(e), () => n.disconnect());
  }, []);
  let B = m0(c, {
    activo: o === `llenar`,
    abajo: 56,
  });
  (0, React.useEffect)(() => {
    let e = c.current;
    if (!e || !M) return;
    let n = N * w0,
      r = e.clientHeight - T0;
    if (
      (n < e.scrollTop
        ? (e.scrollTop = n)
        : n + w0 > e.scrollTop + r && (e.scrollTop = n + w0 - r),
      !t[P]?.fija)
    ) {
      let t = R[P];
      t - ee < e.scrollLeft
        ? (e.scrollLeft = t - ee)
        : t + L[P] > e.scrollLeft + e.clientWidth &&
          (e.scrollLeft = t + L[P] - e.clientWidth);
    }
  }, [N, P, M, t, R, L, ee]);
  let V = () =>
    c.current?.focus({
      preventScroll: !0,
    });
  async function H(e, t, r) {
    let i = `${e.id}:${t.clave}`,
      a = h0(e, t),
      o = typeof r == `string` ? r.trim() : r;
    if ((o ?? ``) !== (t.editar === `texto` ? a : (e[t.clave] ?? ``))) {
      y((e) => new Set(e).add(i));
      try {
        await n(e, t.clave, o === `` ? null : o);
      } finally {
        y((e) => {
          let t = new Set(e);
          return (t.delete(i), t);
        });
      }
    }
  }
  function ne(e, t) {
    F &&
      I?.editar &&
      _({
        valor: e ?? h0(F, I),
        desdeTecla: t,
      });
  }
  function re(e, n, r = !1) {
    let i = F,
      a = I;
    if ((_(null), e !== void 0 && i && a && H(i, a, e), n)) {
      let e = S0(
        {
          r: N,
          c: P,
        },
        n,
        {
          filas: M,
          columnas: t.length,
          shift: r,
        },
      );
      e && h(e);
    }
    V();
  }
  let ie = (e) => e.target === c.current;
  function U(e) {
    if (!ie(e) || g || w !== null) return;
    if (e.altKey && e.key === `ArrowDown`) {
      (e.preventDefault(), T(P));
      return;
    }
    let n = S0(
      {
        r: N,
        c: P,
      },
      e.key,
      {
        filas: M,
        columnas: t.length,
        ctrl: e.ctrlKey || e.metaKey,
        shift: e.shiftKey,
        pagina: Math.max(1, Math.floor((S - T0) / w0) - 1),
      },
    );
    if (n) {
      (e.preventDefault(), h(n));
      return;
    }
    if (F) {
      if (e.key === `F2`) {
        (e.preventDefault(), I.editar ? ne(void 0, !1) : i?.(F));
        return;
      }
      if ((e.key === `Delete` || e.key === `Backspace`) && I.editar) {
        (e.preventDefault(), H(F, I, ``));
        return;
      }
      e.key.length === 1 &&
        !e.ctrlKey &&
        !e.metaKey &&
        !e.altKey &&
        I.editar &&
        (e.preventDefault(), ne(I.editar === `texto` ? e.key : ``, !0));
    }
  }
  function ae(e) {
    ie(e) &&
      !g &&
      F &&
      (e.preventDefault(), e.clipboardData.setData(`text/plain`, h0(F, I)));
  }
  function oe(e) {
    if (!ie(e) || g || !F || I?.editar !== `texto`) return;
    e.preventDefault();
    let t = e.clipboardData
      .getData(`text/plain`)
      .split(/\r?\n/)[0]
      .split(`	`)[0];
    H(F, I, t);
  }
  let se = Math.max(0, Math.floor(b / w0) - E0),
    ce = Math.min(M, se + Math.ceil(S / w0) + 20),
    le = Object.values(f).some(Boolean) || l;
  return (
    <div
      className={`flex flex-col gap-1`}
      children={[
        <div
          ref={c}
          role={`grid`}
          aria-label={s}
          aria-rowcount={M + 1}
          aria-colcount={t.length}
          aria-activedescendant={F ? `celda-${N}-${P}` : void 0}
          tabIndex={0}
          onKeyDown={U}
          onCopy={ae}
          onPaste={oe}
          onScroll={(e) => x(e.currentTarget.scrollTop)}
          style={{
            height: o === `llenar` ? (B ?? `70vh`) : o,
          }}
          className={`overflow-auto rounded-2xl border border-(--border) outline-none focus-visible:ring-2 focus-visible:ring-(--accent-border)`}
          children={[
            <table
              className={`border-separate border-spacing-0 text-xs`}
              style={{
                width: z,
                tableLayout: `fixed`,
              }}
              children={[
                <colgroup
                  children={L.map((e, n) => (
                    <col
                      key={t[n].clave}
                      style={{
                        width: e,
                      }}
                    />
                  ))}
                />,
                <thead
                  children={
                    <tr
                      role={`row`}
                      children={t.map((n, r) => (
                        <Componente_A0_65_48
                          key={n.clave}
                          col={n}
                          indice={r}
                          activa={r === P}
                          izquierda={n.fija ? R[r] : void 0}
                          orden={l?.clave === n.clave ? l.dir : null}
                          filtrada={!!f[n.clave]}
                          abierto={w === r}
                          onAbrir={() => T(w === r ? null : r)}
                          onCerrar={() => {
                            (T(null), V());
                          }}
                          valores={w === r ? x0(e, n.clave, f, t) : []}
                          permitidos={f[n.clave]}
                          onOrdenar={(e) =>
                            te(
                              {
                                clave: n.clave,
                                dir: e,
                              },
                              f,
                            )
                          }
                          onFiltrar={(e) =>
                            te(l, {
                              ...f,
                              [n.clave]: e,
                            })
                          }
                        />
                      ))}
                    />
                  }
                />,
                <tbody
                  children={[
                    se > 0 && (
                      <tr
                        aria-hidden={`true`}
                        style={{
                          height: se * w0,
                        }}
                      />
                    ),
                    j.slice(se, ce).map((e, n) => {
                      let o = se + n;
                      return (
                        <tr
                          key={e.id}
                          role={`row`}
                          aria-rowindex={o + 2}
                          style={{
                            height: w0,
                          }}
                          className={a(e) ? `opacity-60` : ``}
                          children={t.map((t, n) => {
                            let a = o === N && n === P,
                              s = v.has(`${e.id}:${t.clave}`),
                              c = h0(e, t);
                            return (
                              <td
                                key={t.clave}
                                id={`celda-${o}-${n}`}
                                role={`gridcell`}
                                aria-selected={a}
                                aria-readonly={!t.editar}
                                title={c}
                                onMouseDown={() => {
                                  (!a || !g) &&
                                    (_(null),
                                    h({
                                      r: o,
                                      c: n,
                                    }));
                                }}
                                onDoubleClick={() => {
                                  t.editar ? ne(void 0, !1) : i?.(e);
                                }}
                                style={
                                  t.fija
                                    ? {
                                        left: R[n],
                                      }
                                    : void 0
                                }
                                className={`truncate border-r border-b border-(--border) px-2 ${t.fija ? `sticky z-10 font-medium ${o === N ? `[background:linear-gradient(var(--accent-bg),var(--accent-bg)),var(--bg)]` : `bg-(--bg)`}` : (t.fondo ?? ``)} ${t.claseCelda?.(e) ?? `text-(--text-h)`} ${a ? `outline-2 -outline-offset-2 outline-(--accent)` : ``}`}
                                children={
                                  a && g ? (
                                    t.editar === `texto` ? (
                                      <CeldaEditable
                                        inicial={g.valor}
                                        desdeTecla={g.desdeTecla}
                                        etiqueta={t.titulo}
                                        onTerminar={re}
                                      />
                                    ) : (
                                      <O0
                                        crear={r}
                                        col={t}
                                        fila={e}
                                        onTerminar={re}
                                      />
                                    )
                                  ) : s ? (
                                    (0, JSXRuntime.jsx)(ii, {
                                      className: `h-3.5 w-3.5 animate-spin text-(--text)`,
                                      "aria-label": `Guardando`,
                                    })
                                  ) : (
                                    c || (
                                      <span
                                        className={`text-(--text)/50`}
                                        children={`—`}
                                      />
                                    )
                                  )
                                }
                              />
                            );
                          })}
                        />
                      );
                    }),
                    ce < M && (
                      <tr
                        aria-hidden={`true`}
                        style={{
                          height: (M - ce) * w0,
                        }}
                      />
                    ),
                  ]}
                />,
              ]}
            />,
            M === 0 && (
              <p
                className={`p-4 text-sm text-(--text)`}
                children={`Ninguna fila coincide con los filtros.`}
              />
            ),
          ]}
        />,
        <div
          className={`flex flex-wrap items-center gap-3 px-1 text-xs text-(--text)`}
          children={[
            <span children={F ? `${C0(P)}${N + 1} · ${I.titulo}` : `—`} />,
            <span
              children={[
                M.toLocaleString(`es-PE`),
                ` de `,
                e.length.toLocaleString(`es-PE`),
                ` filas`,
              ]}
            />,
            le && (
              <button
                type={`button`}
                onClick={() => te(null, {})}
                className={`font-medium text-(--accent) hover:underline`}
                children={`Quitar filtros y orden`}
              />
            ),
            <span
              className={`ml-auto hidden lg:inline`}
              children={`Flechas para moverse · escribí para editar · F2 edita · Alt+↓ filtra`}
            />,
          ]}
        />,
      ]}
    />
  );
}
